var render = function render(){var _vm=this,_c=_vm._self._c;return (this.loading)?_c('div',{staticClass:"loading-overlay"},[_c('loader',{attrs:{"size":_vm.size}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }